"use client";

import Script from "next/script";

import useInteractionDeferred from "@/hooks/useInteractionDeferred";
import { env } from "@/env.mjs";

// ----------------------------------------------------------------------------

const CLARITY_PROJECT_ID = "lrbtqwcyjp";

const ClarityTrackerScript = () => {
  const ready = useInteractionDeferred();

  if (!env.NEXT_PUBLIC_ENABLE_PRODUCTION_FEATURES) return null;
  if (!ready) return null;

  return (
    <Script
      id="clarity-tracker"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `(function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "${CLARITY_PROJECT_ID}");`,
      }}
    />
  );
};

export default ClarityTrackerScript;
